(() => {
  const chat = document.querySelector('#chat-drawer shopify-chat');
  if (!chat || chat.dataset.caldrenovaLoadingWired) return;
  chat.dataset.caldrenovaLoadingWired = 'true';
  const watched = new WeakSet();
  let timer, slow = false, lastPanel;
  const observer = new MutationObserver(sync);
  const watch = root => {
    if (!root || watched.has(root)) return;
    watched.add(root);
    observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open', 'shell-ready'] });
  };
  const stopTimer = () => { clearTimeout(timer); timer = undefined; slow = false; };
  function sync() {
    const shell = chat.shadowRoot;
    watch(shell);
    const runtime = shell?.querySelector('shopify-agent-runtime');
    const root = runtime?.shadowRoot;
    watch(root);
    const panel = root?.querySelector('[part="dialog"]');
    if (!panel) return;
    if (lastPanel !== panel) { stopTimer(); lastPanel = panel; }
    if (!root.querySelector('[data-caldrenova-chat-style]')) {
      const style = document.createElement('style');
      style.dataset.caldrenovaChatStyle = '';
      style.textContent = '.caldrenova-chat-loading{position:absolute;z-index:2;inset:76px 12px 12px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:14px;padding:24px;background:var(--shopify-chat-background-color,#fff);color:var(--shopify-chat-text-color,#25201c);text-align:center;font:inherit;pointer-events:auto}.caldrenova-chat-loading[hidden]{display:none!important}.caldrenova-chat-loading p{margin:0;line-height:1.5}.caldrenova-chat-loading__spinner{width:22px;height:22px;border:2px solid #ddd;border-top-color:currentColor;border-radius:50%;animation:caldrenova-chat-spin .8s linear infinite}.caldrenova-chat-contact{font-size:13px;line-height:1.5;color:inherit;text-decoration:underline;text-underline-offset:3px}.caldrenova-chat-fallback{margin:16px 0 0;font:inherit;font-size:13px;line-height:1.5}@keyframes caldrenova-chat-spin{to{transform:rotate(360deg)}}@media(prefers-reduced-motion:reduce){.caldrenova-chat-loading__spinner{animation:none}}';
      root.append(style);
    }
    let status = panel.querySelector('[data-caldrenova-chat-loading]');
    if (!status) {
      status = document.createElement('div');
      status.className = 'caldrenova-chat-loading';
      status.dataset.caldrenovaChatLoading = '';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.innerHTML = '<span class="caldrenova-chat-loading__spinner" aria-hidden="true"></span><p data-caldrenova-chat-copy>Loading chat…</p><a class="caldrenova-chat-contact" href="mailto:support@caldrenova.com">Email support@caldrenova.com</a>';
      panel.append(status);
    }
    const unavailable = panel.classList.contains('panel--unavailable');
    const loading = chat.hasAttribute('open') && !chat.hasAttribute('shell-ready') && !runtime.hasAttribute('shell-ready') && !unavailable;
    if (status.hidden === loading) status.hidden = !loading;
    if (loading && timer === undefined) timer = setTimeout(() => { slow = true; sync(); }, 10000);
    if (!loading) stopTimer();
    const copy = status.querySelector('[data-caldrenova-chat-copy]');
    const message = slow ? 'Chat is taking longer than usual. You can email us while it connects.' : 'Loading chat…';
    if (copy.textContent !== message) copy.textContent = message;
    const errorPanel = panel.querySelector('.panel__unavailable');
    if (unavailable && errorPanel && !errorPanel.querySelector('[data-caldrenova-chat-fallback]')) {
      const fallback = document.createElement('p');
      fallback.className = 'caldrenova-chat-fallback';
      fallback.dataset.caldrenovaChatFallback = '';
      fallback.innerHTML = 'You can also reach us at <a class="caldrenova-chat-contact" href="mailto:support@caldrenova.com">support@caldrenova.com</a>.';
      errorPanel.append(fallback);
    }
  }
  observer.observe(chat, { attributes: true, attributeFilter: ['open', 'shell-ready'] });
  sync();
  customElements.whenDefined('shopify-chat').then(sync);
  customElements.whenDefined('shopify-agent-runtime').then(sync);
  window.addEventListener('pagehide', () => { clearTimeout(timer); });
})();
